export default "__VITE_ASSET__ILYlAyCU__"